import { checkValue } from 'utils';
import { renderWithTooltip } from 'utils/table';

export const columns = [
  {
    title: 'Версия',
    dataIndex: 'version',
    key: 'version',
  },
  {
    title: 'Заголовок',
    dataIndex: 'message',
    key: 'message',
  },
  {
    title: 'Заголовок (кз)',
    dataIndex: 'message_kz',
    key: 'message_kz',
    render: checkValue,
  },
  {
    title: 'Описание',
    dataIndex: 'change_log',
    key: 'change_log',
    render: (text) => renderWithTooltip(text, 35),
  },
  {
    title: 'Описание (кз)',
    dataIndex: 'change_log_kz',
    key: 'change_log_kz',
    render: (text) => renderWithTooltip(text, 35),
  },
  {
    title: 'SOFT обновление',
    dataIndex: 'canEscape',
    key: 'canEscape',
    render: (val) => (val ? 'Да' : 'Нет'),
  },
];
